<form [formGroup]="formBus">
    <div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enabled}" >
      <div class="card-body justify-content-between">
        <div class="row filtros-body">
          <div class="col" style="max-width: 150px">
            <div class="md-form">
              <input value="" type="text" class="form-control" placeholder="" required formControlName="rutProveedor" formatRut />
              <label for="rutProveedor">RUT proveedor</label>
            </div>
          </div>
          <div class="col d-flex">
            <button
              mdbBtn
              type="button"
              class="btn-cuadrado"
              color="secondary"
              mdbWavesEffect
              (click)="abrirModalSeleccionarProveedor()"
            >
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents;">
              {{ proveedorSeleccionado.nombre }}
            </h6>
          </div>
        </div>
      </div>
      <!-- FOOTER -->
      <div
        class="card-footer text-muted filtros-footer"
        style="border-top: 1px solid #dee2e6"
      >
        <div></div>
        <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="iniciaProcesoPago()">
          Realizar pago
        </button>
      </div>
    </div>
    </form>

    <!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="VENDEDOR_CON_DEUDA"
  [permitirVisualizarProveedorSinDeuda]="true" showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>

